<template>
  <LoginModal @close="$emit('close')" :title="title">
    <v-dialog />
    <div class="LoginEntreprise-codes">
      <input
        type="text"
        class="LoginEntreprise-code"
        v-model="code"
        ref="code"
      />
    </div>

    <div class="LoginEntreprise-submit">
      <BSCButton
        typeButton="submit"
        :label="$t('login.label.connect')"
        type="primary"
        :disabled="!canSubmit"
        :loading="loading"
        @click.native="submit"
      />
    </div>
  </LoginModal>
</template>

<script>
import LoginModal from './LoginModal'
import { getRoleByLocalStorage } from '@/utils/function'
import { ACTUAL_ROLE } from '@/utils/consts'

export default {
  name: 'LoginEntreprise',
  components: { LoginModal },
  data() {
    return {
      loading: false,
      code: '',
      title: this.$t('login.entreprise.title')
    }
  },
  computed: {
    canSubmit() {
      return this.code !== ''
    }
  },
  methods: {
    submit() {
      this.loading = true
      if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER) {
        this.$store
          .dispatch('auth/valideCodeEntreprise', this.code)
          .then(() => {
            this.loading = false
            this.$emit('close')
          })
          .catch(e => {
            this.code = ''
            this.loading = false
            this.$log.fatal(e)
            this.$emit('close')
          })
      } else {
        this.$store
          .dispatch('auth/SponsorValidCodeEnterprise', this.code)
          .then(() => {
            this.loading = false
            this.$emit('close')
          })
          .catch(e => {
            this.code = ''
            this.loading = false
            this.$log.fatal(e)
            this.$emit('close')
          })
      }
    }
  }
}
</script>

<style lang="scss">
.LoginEntreprise {
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  padding: 1.5rem 0;
  transition-duration: 0.5s;

  &-codes {
    display: flex;
  }

  &-submit {
    margin-top: 2rem;
  }
}
</style>
